import React from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { CCAssessmentType, EnrollmentCertificate } from "../../../Physician/Models/CCEnrollment";
import { Certificate, CertificateStatus, CertificationGeneration } from "../../../Physician/Models/Certificate";
import Physician from "../../../Physician/Models/Physician";
import { getDateWithOffset } from "../../../Shared/Utility/GetDateWithOffset";

interface IProps{
    physician: Physician;
}

export default function CCEnrollmentSummary(props: IProps) {
    const isEnrolledinCC = props.physician.currentCCEnrollment != null;
    const lifeTimeActiveCertificates = props.physician.certificates.filter(cert => cert.certificationGeneration === CertificationGeneration.Lifetime && cert.certificateStatus == CertificateStatus.Active);

    const getCcAssessmentTypeName = (ccAssessmentType: CCAssessmentType ) => {
        switch(ccAssessmentType){
            case CCAssessmentType.Exam:
                return <span>Examination Pathway</span>;
            case CCAssessmentType.Article:
                return <span>Article Based Continuing Certification (ABCC)</span>;
            default:
                return <span className="pp-font-size-smallest">ABPN's ABCC pathway is not an option for this certification. <br />Please see the <a target="_BLANK" href="https://www.abpn.org/maintain-certification/taking-a-moc-exam/subspecialty-moc-exams/">ABPN Website</a> for more details.</span>
        }
    }

    const getCCEnrollmentCertificateListItem = (ccEnrollmentCertificate: EnrollmentCertificate) => {

        const certificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == ccEnrollmentCertificate.certificateId);
        if (!certificate) return "";
        
        var ccCertEnrollmentStartDate = getDateWithOffset(ccEnrollmentCertificate.enrollmentStartDate)

        return <React.Fragment>
            <Row key={certificate.certificateId}>
                <Col>
                    {certificate.certificationName}
                    { ccCertEnrollmentStartDate > new Date() && <div className="subscript">(Requirements Begin: {ccCertEnrollmentStartDate.toLocaleDateString('en-US')})</div>}
                </Col>
                <Col>{getCcAssessmentTypeName(ccEnrollmentCertificate.ccAssessmentType)}</Col>
            </Row>
            <hr />
        </React.Fragment>
    }
    let activeAndFutureEnollmentCertificates = props.physician.currentCCEnrollment && Object.values(props.physician.currentCCEnrollment.activeEnrollmentCertificates).concat(Object.values(props.physician.currentCCEnrollment.futureEnrollmentCertificates));
    let sortedEnrollmentCertificates = activeAndFutureEnollmentCertificates && activeAndFutureEnollmentCertificates.sort((a: EnrollmentCertificate, b: EnrollmentCertificate) => {
        
        //sort by Specialty/Subspecialty
        const aCertificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == a.certificateId);
        const bCertificate = props.physician.certificates.find((cert: Certificate) => cert.certificateId == b.certificateId);
        if (!aCertificate || !bCertificate) return 0;

        if (aCertificate.isPrimary === bCertificate.isPrimary) {
            //then by recent Award Date
            return getDateWithOffset(aCertificate.awardDate).getTime() - getDateWithOffset(bCertificate.awardDate).getTime();
        } else {
            return aCertificate.isPrimary ? -1 : 1
        }
    });

    
    return(
        <Card className="mb-4 pp-pathway-card" border="pp-secondary-grey" bg="pp-background">
                <Card.Body>
                    <Card.Title className="mb-0 font-weight-bolder">
                        <span className="text-uppercase">
                            Continuing Certification Enrollment
                        </span>
                    </Card.Title>
                    <Row>
                        <Col>
                            {isEnrolledinCC && 
                                <Row>
                                    <Col>
                                    <Row>
                                        <Col className="mb-2">Certificates enrolled in the Continuing Certification (CC) Program:</Col>
                                    </Row>
                                    <Row>
                                        <Col className="mb-1"><strong>Certification</strong></Col>
                                        <Col className="mb-1"><strong>Pathway</strong></Col>
                                    </Row>
                                    
                                        {sortedEnrollmentCertificates.map((enrollmentCertificate: EnrollmentCertificate) => {
                                            return getCCEnrollmentCertificateListItem(enrollmentCertificate);
                                        })}
                                    
                                    <Row>
                                        <Col className="mb-2">
                                            *** Access to the ABCC Platform and Managing CC Enrollments will be available in late January 2025.
                                        </Col>
                                    </Row>
                                    </Col>
                                </Row>
                                }

                            {!isEnrolledinCC && lifeTimeActiveCertificates?.length > 0 &&
                                <div>
                                    <p>You are not currently enrolled in the Continuing Certification (CC) Program</p>
                                </div>
                            }
                        </Col>    
                    </Row>
                </Card.Body>
        </Card>
    );

}